
































import { ComponentInternalInstance, getCurrentInstance, computed, defineComponent } from '@vue/composition-api';
import _ from 'lodash';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import accountAssociationHandler from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/accountAssociationHandler';
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RemoveConfigConfirm,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const { delegateOrgInfo, methods: associationMethods } = accountAssociationHandler();
    const methods = {
      getConfigInfo() {
        associationMethods.getDelegateInfo();
      },
      onClose() {
        innerShow.value = false;
      },
    };
    methods.getConfigInfo();
    return {
      innerShow,
      delegateOrgInfo,
      ...methods,
      associationMethods,
    };
  },
});
